import { StickyPositionEnum } from 'common/components/entities/Section/enums/StickyPositionEnum'

export const stickyPositionLockKeys: Record<StickyPositionEnum, string> = {
  [StickyPositionEnum.top]: 'settings_options.sticky.choices.top',
  [StickyPositionEnum.bottom]: 'settings_options.sticky.choices.bottom',
}
